import { Controller } from "@hotwired/stimulus"
import { Toast, initMDB } from 'mdb-ui-kit'; // Import the Toast class from MDB UI Kit
initMDB({ Toast }); // Initialize MDB UI Kit with the Toast class

export default class extends Controller {
  static targets = []

  connect() {
    var toastElList = [].slice.call(document.querySelectorAll('.toast'))
    var toastList = toastElList.map(function(toastEl) {
      return new Toast(toastEl, { delay: 3000 }).show() // No need for options; use the default options
    })
  }
}
